const template = document.createElement('template')
const style = `
<style>
	:host {
		font-family: "Roboto", sans-serif;
		white-space: normal;
	}
	article {
		container-type: inline-size;
    display: flex;
		gap: 1rem;
	}
	article:hover > h4 {
		text-decoration: underline;
	}
	img {
		height: 100%;
		width: 100%;
		object-fit: cover;
	}
	h4 {
		display: -webkit-box;
		font-size: 1.25rem;
    font-weight: 600;
    color: #001f33;
		line-height: 1.25;
    margin-bottom: 0.625rem;
		margin-block: 0;
		overflow: hidden;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 3;
		@container (max-width: 475px) {
			font-size: 1.125rem;
		}
		@container (max-width: 350px) {
			font-size: 1rem;
		}
		@container (max-width: 200px) {
			font-size: 0.875rem;
		}
	}
	#source {
		font-size: 1rem;
    color: #26a8ff;
		@container (max-width: 475px) {
			font-size: 0.875rem;
		}
		@container (max-width: 350px) {
			font-size: 0.75rem;
		}
		@container (max-width: 200px) {
			font-size: 0.625rem;
		}
	}
	#date-time {
		font-size: 0.875rem;
    color: #002d4a;
		@container (max-width: 475px) {
			font-size: 0.75rem;
		}
		@container (max-width: 350px) {
			font-size: 0.625rem;
		}
	}
	.article-details {
		display: flex;
    flex-direction: column;
		justify-content: space-between;
    flex: 1;
	}
	.image-wrapper {
		aspect-ratio: 16 / 9;
		border-radius: 8px;
    display: flex;
		height: auto;
    max-width: 14rem;
		overflow: hidden;
		width: 100%;
		transition: max-width 0.3s;
		@container (max-width: 760px) {
			aspect-ratio: unset;
			max-width: 12.5rem;
		}
		@container (max-width: 450px) {
			aspect-ratio: unset;
			max-width: 11rem;
		}
		@container (max-width: 360px) {
			aspect-ratio: unset;
			max-width: 9rem;
		}
	}
	.source-datetime-container {
		align-items: center;
		display: flex;
		gap: 0.5rem;
	}
</style>
`
const component = `
<article>
	<div class="article-details">
		<h4></h4>
		<div class="source-datetime-container">
			<div id="source"></div>
			<div id="date-time"></div>
		</div>
	</div>
	<div class="image-wrapper">
		<img alt="Article image/thumbnail" src="" />
	</div>
</article>
`
template.innerHTML = `
${style}
${component}
`

import { parseDate } from '../lib/datetime'

export class ListItem extends HTMLElement {

	constructor() {
		super();
		const shadowRoot = this.attachShadow({ mode: 'open' });
		const clone = template.content.cloneNode(true);
		shadowRoot.append(clone);
	}

	public connectedCallback() {
		this.render();
	}
	
	public render() {
		if (!this.shadowRoot)
			return
		const published = this.dataset.publish;
		const source = this.dataset.source;
		const thumbnail = this.dataset.thumbnail;
		const title = this.dataset.title;

		// Update image source
		const img = this.shadowRoot.querySelector('img');
		if (img) {
			img.setAttribute('src', thumbnail || '');
		}
		// Update publisher source
		const sourceEl = this.shadowRoot.querySelector('#source') as HTMLElement;
		if (sourceEl) {
			sourceEl.innerText = source || '';
		}
		// Update published date/time
		const publishedEl = this.shadowRoot.querySelector('#date-time') as HTMLElement;
		if (publishedEl) {
			publishedEl.innerText = parseDate(published || '') || '';
		}
		// Update title
		const h4 = this.shadowRoot.querySelector('h4');
		if (h4) {
			h4.innerText = title || '';
		}
	}
}

customElements.define('list-item', ListItem)
